export default __webpack_public_path__ + "3ca357762d2b0f1fa95d9c5eec57add0.svg";